import folder from "../assets/icons/darkIcons/folder.svg";
import file from "../assets/icons/darkIcons/file-text.svg";
import chart from "../assets/icons/darkIcons/pie-chart.svg";
import users from "../assets/icons/darkIcons/users.svg";
import tresorerie from "../assets/icons/darkIcons/bar-chart.svg";
import watch from "../assets/icons/darkIcons/watch.svg";
import bookUser from "../assets/icons/darkIcons/book-user.svg";
import gear from "../assets/icons/darkIcons/settings.svg";

export const dataMenu = [
  {
    id: 1,
    title: "CRM",
    icon: folder,
    link: "/crm",
    description: "Gestion des clients et missions",
  },
  {
    id: 2,
    title: "Factures",
    icon: file,
    link: "/invoices",
    description: "Facturation, proformas et avoirs",
  },
  {
    id: 3,
    title: "Trésorerie",
    icon: tresorerie,
    link: "/payments",
    description: "Encaissements et impayés",
  },
  {
    id: 4,
    title: "Production",
    icon: chart,
    link: "/productions",
    description: "Etat de production",
  },
  {
    id: 5,
    title: "Staff",
    icon: users,
    link: "/staff",
    description: "Gestion des collaborateurs et évènements",
  },
  {
    id: 6,
    title: "Temps",
    icon: watch,
    link: "/time",
    description: "Gestion du temps",
  },{
    id: 7,
    title: "Social",
    icon: bookUser,
    link: "/social",
    description: "Espace Social",
  },
  {
    id: 8,
    title: "Paramètres",
    icon: gear,
    link: "/settings",
    description: "Paramètres",
  },
];

export const dataMenuCustomerArea = [
  {
    id: 1,
    title: "Social",
    icon: users,
    link: "/customer-area/social",
    description: "Espace Social",
  },
  {
    id: 2,
    title: "Factures",
    icon: file,
    link: "/customer-area/invoices",
    description: "Espace factures",
  },
];
